import { cn } from "@/utils/utils";

interface StudentTypeRecord {
  type?: string | null;
  student_type?: string | null;
}

export function resolveStudentType(record: StudentTypeRecord): string | undefined {
  const value = record.type ?? record.student_type;
  return value?.trim() || undefined;
}

interface StudentTypeBadgeProps {
  type?: string | null;
}

export default function StudentTypeBadge({ type }: StudentTypeBadgeProps) {
  const normalized = (type ?? "").trim().toLowerCase();
  const isClass = normalized === "class";

  if (!normalized || (normalized !== "class" && normalized !== "course")) {
    return (
      <span className="text-[#1F1F1F] text-[16px] font-medium">N/A</span>
    );
  }

  const label = isClass ? "Class" : "Course";

  return (
    <span
      className={cn(
        "inline-flex min-w-[88px] items-center justify-center rounded-full border px-4 py-1 text-[14px] font-medium text-[#1F1F1F]",
        isClass
          ? "border-[#5C88C5] bg-[#E8F0FA]"
          : "border-[#E8B4CB] bg-[#FDF2F8]"
      )}
    >
      {label}
    </span>
  );
}
